"use client";

import { createContext, useContext, useState, useCallback, type PropsWithChildren } from "react";

type HeroVisibilityContextType = {
  isHeroVisible: boolean;
  hideHero: () => void;
  showHero: () => void;
};

const HeroVisibilityContext = createContext<HeroVisibilityContextType | undefined>(undefined);

export const HeroVisibilityProvider = ({ children }: PropsWithChildren) => {
  const [isHeroVisible, setIsHeroVisible] = useState(true);

  const hideHero = useCallback(() => setIsHeroVisible(false), []);
  const showHero = useCallback(() => setIsHeroVisible(true), []);

  return (
    <HeroVisibilityContext.Provider value={{ isHeroVisible, hideHero, showHero }}>
      {children}
    </HeroVisibilityContext.Provider>
  );
};

export const useHeroVisibility = () => {
  const context = useContext(HeroVisibilityContext);
  if (context === undefined) {
    throw new Error("useHeroVisibility must be used within a HeroVisibilityProvider");
  }
  return context;
};
